<script setup lang="ts">
import type { defaultSideItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<defaultSideItemProps>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()

const place = app.$getEventPlace(props.item)
const eyeCatchUrl = storeIndex.getArticleEyeCatchImageURL(props.item.eye_catch_image_object, 's')
</script>

<template>
  <div class="c-reportSideItem">
    <nuxt-link
      v-bind:to="`/report/${item.article_slug}`"
    >
      <v-tooltip
        open-delay="200"
        transition="slide-y-transition"
        max-width="300"
        location="bottom"
      >
        <template v-slot:activator="{ props: slotProps }">
          <CommonImage
            error-src="/images/noimage.svg"
            v-bind:src="eyeCatchUrl"
            v-bind:alt="item.title + ' ' + place"
            class="c-reportSideItem_image"
            v-bind="slotProps"
            aspect-ratio="1 / 1"
            object-fit="cover"
          />
        </template>
        <span>{{ item.title }}<br>{{ place }}</span>
      </v-tooltip>
    </nuxt-link>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-reportSideItem {
  display: flex;
  position: relative;

  a:hover > div {
    opacity: 0.7;
  }

  &_data {
    width: 100%;
    margin-left: 10px;

    &_place {
      margin-top: 1px;
      color: var(--color_text_lightgray);
      font-size: 12px;
    }

    &_name {
      margin-top: 5px;
      margin-bottom: 8px;
      color: var(--color_text_base);
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
